// @flow
import React from 'react';
import styled from 'styled-components';

import Checkbox from 'common/components/ui/Checkbox';
import { translate } from 'react-i18next';

const Sp = styled.p`
  margin-block-start: 0em;
  margin-block-end: 0em;
`;

const NormalLabel = styled(Sp)`
  font-size: 1rem;
`;

const SmallLabel = styled(Sp)`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
`;

interface Props {
  onCreation: boolean,
  hasAccessToFollo: boolean,
  giveAccessToFollo: () => void,
  onGiveAccessToFolloChanged: () => void,

  t: any,
}

function GiveAccessToFolloCheckBox({ onCreation, hasAccessToFollo, giveAccessToFollo, onGiveAccessToFolloChanged, t }: Props) {
  const subLabel = onCreation ? t('accessToFolloIsPermanentOnCreation') : t('accessToFolloIsPermanent');
  const checkBoxLabel = hasAccessToFollo ? (
    <NormalLabel>{t('accessToFolloActivated')}</NormalLabel>
  ) : (
    <React.Fragment>
      <NormalLabel>{t('activateAccessToFollo')}</NormalLabel>
      <SmallLabel>{subLabel}</SmallLabel>
    </React.Fragment>
  );

  return (
    <Checkbox
      onChange={onGiveAccessToFolloChanged}
      checked={giveAccessToFollo}
      disabled={hasAccessToFollo}
      labelPlacement="end"
      label={checkBoxLabel}
    />
  );
}

GiveAccessToFolloCheckBox.defaultProps = {
  onCreation: false,
  hasAccessToFollo: false,
};

export default translate('customers')(GiveAccessToFolloCheckBox);



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/components/GiveAccessToFolloCheckBox.js